import * as React from "react"
import type { ComponentProps } from "react"
import type { UseFormReturn } from "react-hook-form"
import { Command as CommandPrimitive } from "cmdk"

import { Field } from "./Field"
import { YearCombobox } from "./YearCombobox"

type YearFieldProps = {
  form: UseFormReturn
  name: string
  label?: string
  description?: string
  placeholder?: string
  listUntilYear?: number
  triggerClassName?: string
  onBeforeCommit?: (value: string) => string | null
  inputProps?: Omit<ComponentProps<typeof CommandPrimitive.Input>, "value" | "onChange" | "onBlur" | "name">
}

export const YearField = ({
  form,
  name,
  label,
  description,
  placeholder = "Select or type a year",
  listUntilYear = 1900,
  triggerClassName,
  onBeforeCommit,
  inputProps
}: YearFieldProps) => {
  const years = React.useMemo(() => {
    const now = new Date().getFullYear()
    const stop = Math.max(0, Math.min(listUntilYear, now))
    const out: string[] = []
    for (let y = now; y >= stop; y--) out.push(String(y))
    return out
  }, [listUntilYear])

  return (
    <Field
      form={form}
      name={name}
      label={label}
      description={description}
      render={(field) => (
        <YearCombobox
          value={field.value as string | undefined}
          onChange={(next) => {
            const finalValue = onBeforeCommit ? onBeforeCommit(next) : next
            if (finalValue == null) {
              form.setError(name, { type: "manual", message: "Invalid year" })
              return
            }
            form.clearErrors(name)
            field.onChange(finalValue)
          }}
          onBlur={field.onBlur}
          placeholder={placeholder}
          years={years}
          triggerClassName={triggerClassName}
          inputProps={inputProps}
        />
      )}
    />
  )
}
